function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgAndroidIcon = function SvgAndroidIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.007 512.007",
    style: {
      enableBackground: "new 0 0 512.007 512.007"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8BC34A"
    },
    d: "M64.004,192.007c-17.664,0-32,14.336-32,32v128c0,17.664,14.336,32,32,32s32-14.336,32-32v-128 C96.004,206.343,81.668,192.007,64.004,192.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8BC34A"
    },
    d: "M448.004,192.007c-17.664,0-32,14.336-32,32v128c0,17.664,14.336,32,32,32s32-14.336,32-32v-128 C480.004,206.343,465.668,192.007,448.004,192.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8BC34A"
    },
    d: "M128.004,385.863c0,17.664,14.336,32,32,32v62.144c0,17.664,14.336,32,32,32s32-14.336,32-32 v-62.144h64v62.144c0,17.664,14.336,32,32,32s32-14.336,32-32v-62.144c17.664,0,32-14.336,32-32v-192h-256V385.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8BC34A"
    },
    d: "M335.876,60.711l28.48-34.528c5.632-6.816,4.672-16.896-2.144-22.528 c-6.848-5.6-16.896-4.672-22.528,2.144l-31.136,37.728c-16.064-7.264-33.76-11.52-52.544-11.52c-19.04,0-36.96,4.416-53.184,11.904 L172.516,6.023c-5.536-6.88-15.584-8.032-22.496-2.496c-6.88,5.536-8,15.584-2.496,22.496l28.096,35.136 c-28.832,23.456-47.616,58.784-47.616,98.848h256C384.004,119.687,364.996,84.167,335.876,60.711z M224.004,112.007 c-8.832,0-16-7.168-16-16s7.168-16,16-16s16,7.168,16,16S232.836,112.007,224.004,112.007z M288.004,112.007 c-8.832,0-16-7.168-16-16s7.168-16,16-16s16,7.168,16,16S296.836,112.007,288.004,112.007z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAndroidIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/android-icon.a9258695.svg";
export { ForwardRef as ReactComponent };